import { IconButton, Popover, Typography } from '@mui/material';
import { useId, useState } from 'react';
import { HelpOutline } from '@mui/icons-material';

interface InformationComponentProps {
  information: string;
  iconWidth?: string | number;
  iconHeight?: string | number;
}

const InformationComponent = ({
  information,
  iconHeight = 20,
  iconWidth = 20,
}: InformationComponentProps) => {
  const [mousePosition, setMousePosition] = useState<{
    top: number;
    left: number;
  }>();

  const open = Boolean(mousePosition);
  const popoverId = useId();

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setMousePosition({
      top: event.clientY + 14,
      left: event.clientX + 14,
    });
  };

  const handleClose = () => {
    setMousePosition(undefined);
  };

  return (
    <>
      <IconButton
        aria-describedby={popoverId}
        onMouseEnter={handleOpen}
        onMouseLeave={handleClose}
        size="small"
        sx={{ padding: 0 }}
      >
        <HelpOutline
          color={'primary'}
          sx={{ width: iconWidth, height: iconHeight }}
        />
      </IconButton>
      <Popover
        id={popoverId}
        sx={{
          pointerEvents: 'none',
        }}
        open={open}
        onClose={handleClose}
        disableRestoreFocus
        anchorReference="anchorPosition"
        anchorPosition={mousePosition}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        slotProps={{
          paper: {
            sx: {
              padding: (theme) => theme.spacing(1.5),
              border: '1px solid',
              borderColor: (theme) => theme.palette.primary.main,
              borderRadius: 1,
              maxWidth: '350px',
            },
          },
        }}
      >
        <Typography variant="body2" component="p">
          {information}
        </Typography>
      </Popover>
    </>
  );
};

export default InformationComponent;
